import { h } from 'preact'
import { tagParser } from '../../js/modules/utilities'

export const TuileArgument = ({ title, mentions, icon , analytics}) => {
   return (
      <div class="tuile-argument" data-pdb-zid={analytics.pdbZid}>
         <span class={`icon icon-${icon}`}></span>
         <h3 class="h4 title m-0 p-0" dangerouslySetInnerHTML={{ __html: tagParser(title) }} />
         <span class="mentions m-0 p-0">{mentions}</span>
      </div>
   )
}
